import ButtonComponent from "../../components/button";
import InquaryForm from "../../components/InquaryForm";
import PageHeader from "../../components/PageHeader";
import SEO from "../../components/SEO";

export default function MSOffice365() {
  return (
    <>
      {/* Meta Start */}
      <SEO
        title='Microsoft 365 Setup Services in Bhubaneswar | PPM Infotech'
        description=' PPM Infotech offers Microsoft 365 setup in Bhubaneswar including business email, cloud storage, Microsoft Teams and Office apps for secure collaboration.' 
        canonical='https://ppminfotech.com/service/ms-office-365'
      />
      {/* Meta End  */}

      <PageHeader />
      {/* price section  */}
      <section className="price-section py-5">
        <div className="container">
          {/* Title row  */}
          <div className="row">
            {/* <span className="sub-title-left text-center">Price Table</span> */}
            <h3 className="mb-5 service-main-heading heading text-center">
              <strong>Microsoft 365 plan</strong> for your business
            </h3>
          </div>

          {/* content row  */}
          <div className="row price-area mt-4">
            {/* Premium Plan */}
            <div className="pricing-card">
              <p className="package">
                More productive and secure
              </p>
              <h4 className="title">Microsoft 365 Business Premium</h4>

              <span className="pricing-beg">
                Save up to 30%
              </span>

              <hr />

              <ul className="price-feature-list py-3">
                <li className="active">
                  <i className="fa-regular fa-circle-check me-2 available"></i>
                  Advanced Identity Management
                </li>

                <li className="active">
                  <i className="fa-regular fa-circle-check me-2 available"></i>
                  300 User Access
                </li>

                <li className="active">
                  <i className="fa-regular fa-circle-check me-2 available"></i>
                  Word, Excel, PowerPoint
                </li>
                <li className="active">
                  <i className="fa-regular fa-circle-check me-2 available"></i>
                  Chat, call, and meet with Microsoft Teams
                </li>
                <li className="inactive">
                  <i className="fa-regular fa-circle-check me-2 available"></i>
                  Custom Business Email
                </li>

                <li className="inactive">
                  <i className="fa-regular fa-circle-check me-2 available"></i>
                  Microsoft Teams Meetings
                </li>
                <li className="inactive">
                  <i className="fa-regular fa-circle-check me-2 available"></i>
                  1TB Cloud Storage
                </li>
                <li className="inactive">
                  <i className="fa-regular fa-circle-check me-2  available"></i>
                  10+ Business Apps(Microsoft Loop,Clipchamp, Bookings, Planner, and Forms)
                </li>
                <li className="inactive">
                  <i className="fa-regular fa-circle-check me-2  available"></i>
                  AI Writing & Analysis
                </li>
                <li className="inactive">
                  <i className="fa-regular fa-circle-check me-2   available "></i>
                  Cyber Threat Protection
                </li>
                <li className="inactive">
                  <i className="fa-regular fa-circle-check me-2  available  "></i>
                  Data Protection & Compliance
                </li>
                <li className="inactive">
                  <i className="fa-regular fa-circle-check me-2  available  "></i>
                  Anytime phone and web support
                </li>
              </ul>

              <ButtonComponent name={"Contact Us"} path={"/contact  "} />
            </div>

            {/* Standard Plan */}
            <div className="pricing-card">
              <p className="package">
                Powerful web & apps for your business
              </p>
              <h4 className="title">Microsoft 365 Business Standard</h4>

              <span className="pricing-beg">
                Save up to 30%
              </span>

              <hr />

              <ul className="price-feature-list py-3">
                <li className="active">
                  <i className="fa-regular fa-circle-check me-2 available"></i>
                  Identity and access management
                </li>

                <li className="active">
                  <i className="fa-regular fa-circle-check me-2 available"></i>
                  300 User Access
                </li>

                <li className="active">
                  <i className="fa-regular fa-circle-check me-2 available"></i>
                  Word, Excel, PowerPoint
                </li>

                <li className="inactive">
                  <i className="fa-regular fa-circle-check me-2 available"></i>
                  Custom Business Email
                </li>

                <li className="inactive">
                  <i className="fa-regular fa-circle-check me-2 available"></i>
                  Microsoft Teams Meetings
                </li>
                <li className="inactive">
                  <i className="fa-regular fa-circle-check me-2  available"></i>
                  Chat, call, and meet with Microsoft Teams
                </li>
                <li className="inactive">
                  <i className="fa-regular fa-circle-check me-2 available"></i>
                  1TB Cloud Storage
                </li>
                <li className="inactive">
                  <i className="fa-regular fa-circle-check me-2  available"></i>
                  10+ Business Apps(Microsoft Loop,Clipchamp, Bookings, Planner, and Forms)
                </li>
                <li className="inactive">
                  <i className="fa-regular fa-circle-check me-2  available"></i>
                  AI Writing & Analysis
                </li>
                <li className="inactive">
                  <i className="fa-regular fa-circle-check me-2   available "></i>
                  Automatic spam and malware filtering
                </li>
                <li className="inactive">
                  <i className="fa-regular fa-circle-check me-2  available  "></i>
                  Anytime phone and web support
                </li>
              </ul>

              <ButtonComponent name={"Contact Us"} path={"/contact  "} />
            </div>

            {/* Basic Plan */}
            <div className="pricing-card">
              <p className="package">
                Lightweight web and apps for business
              </p>
              <h4 className="title">Microsoft 365 Business Basic</h4>

              <span className="pricing-beg">
                Save up to 30%
              </span>

              <hr />

              <ul className="price-feature-list py-3">
                <li className="active">
                  <i className="fa-regular fa-circle-check me-2 available"></i>
                  Identity and access management
                </li>

                <li className="active">
                  <i className="fa-regular fa-circle-check me-2 available"></i>
                  300 User Access
                </li>

                <li className="active">
                  <i className="fa-regular fa-circle-check me-2 available"></i>
                  Word, Excel, PowerPoint & Outlook
                </li>

                <li className="inactive">
                  <i className="fa-regular fa-circle-check me-2 available"></i>
                  Custom Business Email
                </li>

                <li className="inactive">
                  <i className="fa-regular fa-circle-check me-2 available"></i>
                  Microsoft Teams Meetings
                </li>
                <li className="inactive">
                  <i className="fa-regular fa-circle-check me-2 available"></i>
                  1TB Cloud Storage
                </li>
                <li className="inactive">
                  <i className="fa-regular fa-circle-check me-2  available"></i>
                  10+ Business Apps(Microsoft Loop,Clipchamp, Bookings, Planner, and Forms)
                </li>
                <li className="inactive">
                  <i className="fa-regular fa-circle-check me-2  available"></i>
                  AI Writing & Analysis
                </li>
                <li className="inactive">
                  <i className="fa-regular fa-circle-check me-2  available"></i>
                  Chat, call, and meet with Microsoft Teams
                </li>
                <li className="inactive">
                  <i className="fa-regular fa-circle-check me-2   available "></i>
                  Automatic spam and malware filtering
                </li>
                <li className="inactive">
                  <i className="fa-regular fa-circle-check me-2  available  "></i>
                  Anytime phone and web support
                </li>
              </ul>

              <ButtonComponent name={"Contact Us"} path={"/contact  "} />
            </div>
          </div>
        </div>
      </section>

      {/* Feature section  */}
      <section className="service-feture-full-row py-5 mb-5">
        <div className="container">
          {/* Title row  */}
          <div className="row">
            {/* <span className="sub-title-left text-center">Price Table</span> */}
            <h3 className="mb-3 service-main-heading heading text-center">
              <strong>Apps to fit</strong> for your business
            </h3>
          </div>

          <div className="row mt-4">
            <ServiceFCard
              name="Microsoft Word"
              descp="Document creation and editing solution for reports, proposals, and business documentation with advanced formatting and collaboration features."
              icon="/media/icons/ms-1.png"
            />

            <ServiceFCard
              name="Microsoft Excel"
              descp="Powerful spreadsheet solution for data analysis, financial tracking, reporting, and business insights with formulas, charts, and automation tools."
              icon="/media/icons/ms-2.png"
            />

            <ServiceFCard
              name="Microsoft PowerPoint"
              descp="Create impactful presentations with professional templates, animations, and visual storytelling tools to impress clients and stakeholders."
              icon="/media/icons/ms-3.png"
            />

            <ServiceFCard
              name="Business Email (Outlook)"
              descp="Professional domain-based email solution with advanced security, spam protection, calendar management, and seamless access across desktop and mobile devices."
              icon="/media/icons/ms-4.png"
            />

            <ServiceFCard
              name="Microsoft Teams"
              descp="A complete collaboration platform for chat, video meetings, file sharing, and team communication — enabling smooth workflow and improved productivity."
              icon="/media/icons/ms-5.png"
            />

          </div>
        </div>
      </section>

      <InquaryForm />
    </>
  );
}


function ServiceFCard({ name, icon, descp }) {
  return (
    <div className="servic-f-card-holder  ">
      <div className="servic-f-card  ">
        <img src={icon} alt={name} />
        <div>
          <h5>{name}</h5>
          <p>{descp}</p>
        </div>
      </div>
    </div>

  )

}

export { ServiceFCard };
